<template>
	<toolbar>
		<h2><i class="fa" :class="icon ? icon : 'fa-th-large'"></i> {{ title }}</h2>

		<div class="controls">
			<nav-tabs :tabs="tabs"></nav-tabs>
		</div>
	</toolbar>
</template>

<script>
import NavTabs from "@/layout_fragments/NavTabs"
import Toolbar from "@/layout_fragments/Toolbar"

export default {

	name: 'AppsToolbar',
	components: {
		Toolbar,
		NavTabs
	},
	props: ["title","icon"],
	computed: {
		tabs() {
			let tabs = [
				{
					label: "Manage Installed Apps",
					icon: "fa-th-large",
					path: "/apps/installed",
					modulePermRequired: ["Settings"]
				},
				{
					label: "Marketplace",
					icon: "fa-th-large",
					path: "/apps/store",
					modulePermRequired: ["Settings"]
				},
				{
					label: "Integrations",
					icon: "fa-puzzle-piece",
					path: "/apps/integrations"
				}
			]

			if ("AddonApp" in this.$store.company && this.$store.company.AddonApp) {
				let appsInMainSlot = this.$store.company.AddonApp.filter(app => app.ui_location == "Main")

				if (appsInMainSlot.length > 0) {
					tabs.unshift({
						label: "Apps",
						icon: "fa-th-large",
						path: "/apps/main"
					})
				}
			}

			return tabs
		}
	},
	methods: {
		newButton() {
			this.$emit("newButtonClick")
		}
	}

}
</script>